import { DeviceGroupRow } from 'v2/hooks/useDeviceGroups/useDeviceGroups';
import { FilterState } from './deviceGroupFilterTypes';

type Params = {
  deviceGroups: DeviceGroupRow[];
  filterState: FilterState;
};

export const filterDeviceGroups = ({ deviceGroups, filterState }: Params): DeviceGroupRow[] => {
  let data = deviceGroups;
  if (filterState.noDevices) data = data.filter((group) => group.doors.length === 0);
  if (filterState.noUserGroups) data = data.filter((group) => group.userGroups.length === 0);
  return data;
};
